import ResourcesFTU_Icon from '@assets/images/ResourcesFTU_Icon.svg';
import React from 'react';
import { useIntl } from 'react-intl';
import AccessControlledButton from '../../TapToTip/AccessControlledButton';
import messages from './messages';

const ResourcesBlankSlate = ({ openCreateResources }) => {
  const intl = useIntl();

  return (
    <div className="w-full flex justify-center">
      <div className="flex flex-col items-center text-center bg-slate-50 rounded-3xl shadow-sm border border-solid border-slate-200 p-8 w-full max-w-[480px] mt-6">
        <img
          src={ResourcesFTU_Icon}
          className="h-[102px] w-[102px] rounded-full mb-4"
          alt="Resources blank slate icon"
        />
        <div className="text-xl font-bold text-slate-800 mb-1">
          {intl.formatMessage(messages.title)}
        </div>
        <div className="text-sm font-semibold text-slate-600 mb-2">
          {intl.formatMessage(messages.subTitle)}
        </div>
        <div className="text-sm text-slate-500 mb-6">{intl.formatMessage(messages.text)}</div>
        {openCreateResources && (
          <AccessControlledButton
            elementStyle="w-full sm:w-auto !px-5 !py-2.5 !border !border-solid !border-transparent !normal-case"
            feature={'ResourceTippingPoints'}
            tooltipTitle={''}
            title={intl.formatMessage(messages.createResource)}
            onClick={openCreateResources}
          />
        )}
      </div>
    </div>
  );
};

export default ResourcesBlankSlate;
